export default "__VITE_ASSET__CC62ii$n__"